<template>
  <NumberField
    :id="`tender-max-swipes-${index}`"
    :name="fieldName"
    :label="translate(`${LOCALE_PREFIX}.form.tenders.tenderSetup.maxSwipes`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.tenders.tenderSetup.maxSwipesPlaceholder`)"
    :useGrouping="false"
    :required="true"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { SitesLocalePrefix } from '../../../../../enums';

// Define props
defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;
</script>
